import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { operationsHubCards } from "../../navigation/appNavigation";
import { SectionLabels } from "../../utils/navigation/pageTitles";

const OperationsHubPage = () => (
    <SectionHubPage title={SectionLabels.operations} cards={operationsHubCards} />
);

export { OperationsHubPage };
